import { useMemo } from 'react';

import { PHONE_AB_TEST, VariationEnum } from '@helpers/abtest-utils';
import { RouteModel, paiementRoute } from '@helpers/routes';

export function useShouldShowPhoneStep(stepRoute: RouteModel | undefined): boolean | null {
    return useMemo(() => {
        if (typeof window === 'undefined') return false;

        const variant = localStorage.getItem(PHONE_AB_TEST) as VariationEnum | null;
        const effectiveVariant = variant ?? VariationEnum.VARIATION_B;
        const isVariantA = effectiveVariant === VariationEnum.VARIATION_A;

        if (!isVariantA) {
            return false;
        }

        const isCurrentStepBeyondPhone = stepRoute && stepRoute.step > paiementRoute.step;

        if (isCurrentStepBeyondPhone) {
            return false;
        }

        return true;
    }, [stepRoute]);
}
